import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Image } from "react-bootstrap";

import logo2 from "../assets/images/logo2.png";
import "./SignUp/onBoarding/job-title.css";

import Loader from "./Utility/Loader";
import * as userAction from "../actions/user";
import * as authAction from "../actions/authentication";
import { useAlert } from "../Context/AlertModalContext";

export default function AccountNotApproved() {
  const alert = useAlert();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchRejectionDetails = useCallback(async () => {
    setLoading(true);
    try {
      const response = await authAction.checkRejection();
      if (response?.status && response?.reason) {
        setData(response);
      } else {
        console.error("Failed to fetch rejection details");
      }
    } catch (error) {
      console.error("Error fetching rejection details:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRejectionDetails();
  }, [fetchRejectionDetails]);

  const updateStatus = useCallback(async () => {
    setLoading(true);
    try {
      const response = await userAction.updateStatusAgain();
      if (!response) {
        throw new Error("No response from updateStatusAgain");
      }

      alert.setModal({
        show: true,
        message: "Profile approval request sent successfully.",
        title: "Success",
      });

      navigate("/user/home");
    } catch (error) {
      console.error("Error updating status:", error);
      alert.setModal({
        show: true,
        message: "Failed to send approval request. Please try again.",
        title: "Error",
      });
    } finally {
      setLoading(false);
    }
  }, [alert, navigate]);

  return (
    <div className="job-container">
      {loading && <Loader />}
      <Container className="job-main">
        <Container className="job-content" style={{ gap: "0px", height: "95dvh" }}>
          <Container className="logo-progressbar10">
            <Container className="logo-arrow10">
              <Image src={logo2} alt="Logo" className="logo" style={{ backgroundColor: "transparent" }} />
            </Container>
          </Container>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "2rem",
              gap: "1rem",
              alignItems: "center",
              textAlign: "center",
              justifyContent: "center",
            }}
          >
            <svg width="87" height="87" viewBox="0 0 87 87" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M43.5 21.75C47.4875 21.75 50.75 25.0125 50.75 29C50.75 32.9875 47.4875 36.25 43.5 36.25C39.5125 36.25 36.25 32.9875 36.25 29C36.25 25.0125 39.5125 21.75 43.5 21.75ZM43.5 58C53.2875 58 64.525 62.6763 65.25 65.25H21.75C22.5837 62.64 33.7488 58 43.5 58ZM43.5 14.5C35.4888 14.5 29 20.9887 29 29C29 37.0112 35.4888 43.5 43.5 43.5C51.5112 43.5 58 37.0112 58 29C58 20.9887 51.5112 14.5 43.5 14.5ZM43.5 50.75C33.8212 50.75 14.5 55.6075 14.5 65.25V72.5H72.5V65.25C72.5 55.6075 53.1787 50.75 43.5 50.75Z"
                fill="#4E1173"
              />
            </svg>

            <p style={{ fontSize: "24px", fontWeight: "bold", lineHeight: "36px", marginTop: "-20px" }}>
              Sorry, we can’t approve your profile just yet.
            </p>

            <p
              style={{
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "20px",
                color: "#6c6c6c",
                fontFamily: "Inter, sans-serif",
              }}
            >
              We're excited to help you find your perfect match! But we need a few more details to approve your profile.
              Please update the following information.
            </p>
          </div>

          {data && (
            <p
              style={{
                marginBottom: "2rem",
                fontSize: "16px",
                fontWeight: "500",
                textAlign: "center",
                padding: "12px",
                borderRadius: "16px",
                backgroundColor: "#f8f8f8",
              }}
            >
              Hi there! Having a complete profile helps you connect better with others. Please complete your bio and add
              real images which clearly show your face.
            </p>
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              marginTop: "-18px",
              marginBottom: "3rem",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <button className="global-next-btn" style={{ width: "267px", marginBottom: "10px" }} onClick={updateStatus}>
              Resubmit for Approval
            </button>
            <p style={{ fontFamily: "Inter, sans-serif", color: "#4e1173", fontSize: "16px" }}>Almost there!</p>
            <p style={{ marginTop: "1em", fontSize: "16px" }}>
              Have questions? Contact us at <strong>hello@myTamilDate.com</strong>
            </p>
          </div>
        </Container>
      </Container>
    </div>
  );
}